<div class="tax-dialog">
    <h3
        class="mb-3"
        i18n="@@5212295fdfb04a53e5c99436b141e4c4f989dfd7"
        t="5212295fdfb04a53e5c99436b141e4c4f989dfd7"
        >Tax Information</h3
    >
    <tax-edit
        #taxEditComponent
        [tsl-supplierCode]="supplierCode"
        [tsl-requiredDocuments]="requiredDocuments"
        [tsl-supplierTax]="supplierTaxInfo"
        [tsl-readOnly]="false"
        [tsl-generalSettings]="settings$ | async"
        [tsl-countries]="taxCountries$ | async"
        [tsl-hideSaveButton]="false"
        [tsl-hideCancelButton]="false"
        [tsl-saveButtonText]="'Save'"
        (tsl-onSave)="saveHandler($event.supplierTaxInfo)"
        (tsl-onCancel)="cancelHandler()"
        [tsl-taxDocuments]="taxDocuments"
    >
    </tax-edit>
</div>
